import $ from 'jquery';

const MOBILE_BREAKPOINT = 767;

$(function () {
    let $body = $('body');
    let $menu = $('#site-navigation');
    let $triggerOpen = $('.mobile-menu-open');
    let $triggerClose = $('.mobile-menu-close');

    $triggerOpen.on('click', function () {
        if ($(window).width() <= MOBILE_BREAKPOINT) {
            $menu.addClass('open');
            $body.addClass('mobile-menu-open');
        }
    });

    $triggerClose.on('click', function () {
        if ($(window).width() <= MOBILE_BREAKPOINT) {
            $menu.removeClass('open');
            $body.removeClass('mobile-menu-open');
        }
    });
});



// WEBPACK FOOTER //
// ./resources/assets/js/components/MobileMenu.js